module.exports = __webpack_public_path__ + "media/images/app-builder-bg-1f951c5b.svg";